import { REPORT_ENDPOINT } from './RootEndpoint';

export const RESERVATION_LIST_REPORT_ENDPOINT = `${REPORT_ENDPOINT}/reservation-list`;
